import brandCatQuery from '../Queries/LookupBrandQuery.gql'
import { useQuery } from '@apollo/react-hooks'

export function useHandleBrandCat(product) {
   const brand =
      product?.customFields.find(p => p.key == 'varumarke')?.stringValue ?? ''

   const brandQueryResult = useQuery(brandCatQuery, {
      variables: { searchTerm: brand },
   })

   const brandCatData =
      brandQueryResult?.data?.search?.categories?.result?.find(
         c => c.name == brand
      )
      
   return {
      brandCat: brandCatData,
      brandQueryLoading: brandQueryResult?.loading,
   }
}